import React, { useState, useEffect } from 'react';

import Td from 'components/Td';
import { LoanApplication, DiscountType } from 'generated/graphql';
import { ISimulationResult } from 'interfaces/interfaces';
import { recalculateSimulationResult } from 'utils/simulation-utils';
import { formatMoney } from 'utils/utils';

interface IPaymentSummaryProps {
    loanApplication: LoanApplication;
    discounts: DiscountType[];
    className?: string;
    productBizId?: string;
}

const PaymentSummary: React.FC<IPaymentSummaryProps> = (props): JSX.Element => {
    const { loanApplication, discounts, productBizId } = props;
    const { acceptedProposal } = loanApplication;

    const [isDesktop, setDesktop] = useState(false);

    useEffect(() => {
        setDesktop(window.innerWidth > 767);
    }, [window.innerWidth]);

    const [simulation, setSimulation] = useState({cet: {}} as ISimulationResult);

    useEffect(() => {
        if(!acceptedProposal.interestRate || !acceptedProposal.tenure) {
            return null;
        }
        setSimulation(recalculateSimulationResult(loanApplication, discounts, productBizId));
    }, [acceptedProposal,discounts]);



    return (
        <div className="grid-summary highlight-card">
            <div className="pt-4 px-4 grid-summary-body">
                <h3 className="mb-4 mt-3">
                    seu empréstimo na biz
                </h3>
                <table className="table table-borderless table-sm">
                    <tbody>
                        <tr className="font-weight-bolder">
                            <td>
                                Empréstimo
                            </td>
                            <Td value={acceptedProposal.amount} />
                        </tr>
                        <tr>
                            <td>
                                Juros
                            </td>
                            <Td value={simulation.interestAmount} />
                        </tr>
                        <tr>
                            <td>
                                IOF
                            </td>
                            <Td value={simulation.iof} />
                        </tr>
                        <tr>
                            <td>
                                Tarifa de cadastro
                            </td>
                            <td>
                                {/* {acceptedProposal.fixedComission ?
                                    <Fragment>
                                        <div className="outdated-value">
                                            R$ {formatMoney(simulation.originalComission)}
                                        </div>
                                        <div className="current-value">
                                            R$ {formatMoney(simulation.finalComission)}
                                        </div>
                                    </Fragment>
                                    : */}
                                    <div>
                                        R$ {formatMoney(simulation.finalComission)}
                                    </div>
                                {/* } */}
                            </td>
                        </tr>
                        <tr className="total-line">
                            <td>
                                Total a pagar
                            </td>
                            <Td value={simulation.total} />
                        </tr>
                    </tbody>
                </table>
                {!isDesktop &&
                    <p className="mobile-only">
                        O Custo Efetivo Total (CET) é de {(simulation.cet.monthlyRate * 100).toFixed(2)}% ao mês ou {(simulation.cet.annualyRate * 100).toFixed(2)}%
                        ao ano e já está incluído no valor total a pagar
                    </p>
                }
            </div>
            <div className="grid-summary-footer border-top mt-3 px-4 pt-4 pb-2">
                <div>
                    {isDesktop &&
                        <h4 className="desktop-only">
                            Pagamento em <span className="font-weight-bold">{acceptedProposal.tenure} parcelas</span> de
                        </h4>
                    }
                    {!isDesktop &&
                        <h4 className="mobile-only">
                            <span className="font-weight-bold">{acceptedProposal.tenure}</span> parcelas de
                        </h4>
                    }
                    <h2 className="primary-text">
                        {formatMoney(simulation.pmt)}
                    </h2>
                </div>
                {
                    props.children
                }
                {isDesktop &&
                    <p className="desktop-only">
                        O Custo Efetivo Total (CET) é de {(simulation.cet.monthlyRate * 100).toFixed(2)}% ao mês ou {(simulation.cet.annualyRate * 100).toFixed(2)}%
                        ao ano e já está incluído no valor total a pagar
                    </p>
                }
            </div>
        </div>
    );
};

export default PaymentSummary;
